import React, { Component } from 'react';
import classNames from 'classnames';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} videoPath
 * @prop {Boolean} isToggled
 * @prop {Boolean} autoPlay
 * @prop {Boolean} controls
 * @prop {String} [className]
 *
 * @augments {Component<Props>}
 */
export default class HTMLVideoPlayer extends Component {

	// checks for isToggled prop and rerenders
	componentDidUpdate (prevProps) {
		if (this.props.isToggled !== prevProps.isToggled && !this.props.isToggled) {
			this.videoRef.current.pause();
		}
	}

	videoRef = React.createRef();

	genClassName = (props) => classNames('HTMLVideoPlayer', props.className);

	render () {
		const { controls, videoPath } = this.props;
		return (
			<div className={this.genClassName(this.props)}>
				<video
					ref={this.videoRef}
					controls={controls}
				>
					<source src={videoPath} />
				</video>
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/HTMLVideoPlayer/HTMLVideoPlayer.js